import { render, staticRenderFns } from "./TopCategoryBook.vue?vue&type=template&id=7fc76ff1&"
import script from "./TopCategoryBook.vue?vue&type=script&lang=js&"
export * from "./TopCategoryBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports